(function() {
    'use strict';

    angular
        .module('quantixApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('infrastructureProjects', {
            parent: 'app',
            url: '/infrastructureProjects',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/company/infrastructureProjects/infrastructureProjects.html',
                    controller: 'InfrastructureProjectsController'
                }
            }
        })
                .state(
				'infraDetails',
				{
					parent : 'infrastructureProjects',
					url : '/infraDetails',
					
		            data: {
		                authorities: []
		            },

					params:{
						
						data :null,
						modelName:null,
						selectedFilter:null
					},
					views : {
						'content@' : {
							templateUrl : 'app/company/infrastructureProjects/infrastructureProjectDetails.html',
							controller : 'InfrastructureProjectsDetailsController',
							controllerAs : 'vm'
						}
					}
				})
        
    }
})();
